// NOTE snake_case used to avoid aliasing a method named in backend code
import { SleepDiaryPayloads } from '@bighealth/types/src/services/SleepDiaryPayloads';
import { DiaryEntry } from '@bighealth/types/src/services/SleepDiaryPayloads/types';

/**
 *
 * @param {DiaryEntry} args
 */
const create_single_day_entry = (
  args: DiaryEntry
): SleepDiaryPayloads['create_single_day_entry']['request'] => {
  return {
    service_name: 'SleepDiary',
    service_version: '1',
    service_method: 'create_single_day_entry',
    args,
  };
};

export { create_single_day_entry };
